import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';
import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil, tap } from 'rxjs/operators';
import { FaultArticleService, SeoService } from '../../shared/services';

import {
  AlertModule,
  IconModule,
  VmThemeProviderModule,
  SectionModule,
  BreadcrumbsModule,
  RemoveFromViewModule,
  RemoveFromViewDirective,
  TabsModule,
  TileModule,
  TypeModule,
  FormItemModule,
  FormInputModule,
} from '@virginmediao2/momentum-angular';
import { SmartBreadcrumbsModule } from '@virginmediao2/momentum-angular/smart';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MarkdownModule } from 'ngx-markdown';
import { CommonModule } from '@angular/common';
import { BaseComponent } from '@/shared/components/base/base.component';
import { AnalyticsCTADirective } from '@/shared/directives/analytics-cta.directive';

@Component({
  selector: 'vm-search-tv-error-code',
  templateUrl: './search-tv-error-code.component.html',
  styleUrls: ['./search-tv-error-code.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
  imports: [
    CommonModule,
    VmThemeProviderModule,
    BreadcrumbsModule,
    SectionModule,
    IconModule,
    ReactiveFormsModule,
    RemoveFromViewDirective,
    MarkdownModule,
    FormsModule,
    CdkConnectedOverlay,
    CdkOverlayOrigin,
    AlertModule,
    AnalyticsCTADirective,
    TabsModule,
    TileModule,
    TypeModule,
    FormItemModule,
    FormInputModule,
    SmartBreadcrumbsModule,
    RemoveFromViewModule,
  ],
  providers: [],
})
export class SearchTvErrorCodeComponent extends BaseComponent implements OnInit {
  private faultArticleService = inject(FaultArticleService);
  private seoService = inject(SeoService);
  private router = inject(Router);

  @ViewChild('overlay') overlay: CdkConnectedOverlay;

  faultArticleUID = 'dc_tv-error-codes_landing';
  faultArticleData: any;

  searchCtrl = new FormControl();
  shouldShowOverlay = false;
  hideOverlay = false;
  destroy$: Subject<void> = new Subject();
  searchTerm$: Observable<string[]>;
  searchResults: any[] = [];
  tvErrorCodesData: any[] = [];
  filterCodes: any[] = [];
  tvErrorCodesMainContent!: any;
  tvErrorCodesSearchContent!: any;
  streamBoxNotification!: any;
  findYourErrorCode!: any;
  homeUrl = location.origin;
  breadcrumbs = [
    { name: 'Help', routerLink: 'https://www.virginmedia.com/help' },
    { name: 'TV', routerLink: 'https://www.virginmedia.com/help/tv' },
    { name: 'TV error codes', routerLink: '' },
  ];

  @HostListener('window:resize')
  onWinResize() {
    this.overlay?.overlayRef.updatePosition();
  }

  ngOnInit() {
    this.loadTVErrorCodes().subscribe((result) => {
      // console.log('article result: ', result);
    });

    this.searchTerm$ = this.searchCtrl.valueChanges.pipe(
      takeUntil(this.destroy$),
      map((searchTerm: string) => {
        if (!searchTerm) {
          return [];
        }
        return this.tvErrorCodesData.filter((tvErrorCode) =>
          tvErrorCode.label.toLowerCase().includes(searchTerm.toLowerCase())
        );
      }),
      tap((searchResults) => {
        this.searchResults = searchResults;
        this.shouldShowOverlay = this.searchCtrl.value || searchResults.length;
      })
    );
  }

  loadTVErrorCodes() {
    return this.faultArticleService.getArticle(this.faultArticleUID).pipe(
      map((strapiData) => {
        this.tvErrorCodesMainContent = strapiData.elements[0];
        this.tvErrorCodesSearchContent = strapiData.elements[1];
        this.streamBoxNotification = strapiData.elements[2];
        this.findYourErrorCode = strapiData.elements[3];
        this.tvErrorCodesData = strapiData.elements[4].ctas;

        this.filterTabErrorCodes();

        if (strapiData.titleOfTheBrowser) {
          this.seoService.updatePageTitle(strapiData.titleOfTheBrowser);
        }

        if (strapiData.metaTagSection.length) {
          this.seoService.updateMetaTags(strapiData?.metaTagSection);
        }
      })
    );
  }

  filterTabErrorCodes() {
    this.findYourErrorCode.ctas?.map((cta) => {
      this.filterCodes[cta?.dataAttrValue] = this.tvErrorCodesData.map((tvErrorCode) =>
        this.displayFilterTileErrorCodes(tvErrorCode, cta?.dataAttrValue)
      );
    });
  }

  filterTileErrorCodes(selected) {
    this.filterCodes = this.tvErrorCodesData.map((tvErrorCode) =>
      this.displayFilterTileErrorCodes(tvErrorCode, selected)
    );
  }

  displayFilterTileErrorCodes(tvErrorCode, selected) {
    const regEx = new RegExp('^[' + selected + ']');
    if (regEx.test(tvErrorCode.label)) {
      return { ...tvErrorCode, display: true };
    }
    return {};
  }

  errorCodeClick(url) {
    if (!url.includes('http')) {
      this.router.navigate([url]);
    } else {
      document.location.href = url;
    }
    this.shouldShowOverlay = false;
  }
}
